import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./MaterialFile.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import { loaderOverlay } from "../../../Style/loaderOverly.js";
import NumberInput from "../../../custom/components/Number-Input/NumberInput.js";

const MaterialCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const schema = localStorage.getItem('schema')
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categorySelectOptions, setCategorySelectOptions] = useState([])

  const [selectedUom, setSelectedUom] = useState(null);
  const [uomSelectOptions, setUomSelectOptions] = useState([])

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);




  useEffect(() => {
    getCategoryData()
    getUomData()
  }, [])


  const getEditData = async (id) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      }

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data })
        setSelectedCategory({ value: data?.category_id, label: data?.category?.name })        
        setSelectedUom({ value: data?.uom_id, label: data?.uom?.name })
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getCategoryData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "category_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.name
      }));
      setCategorySelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const getUomData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "uom_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.name
      }));
      setUomSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };




  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {

      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleCategorySelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      category_id: selectedValue,
    });

    setSelectedCategory(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      category_id: fieldError?.category_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        category_id: selectedValue,
      },
    }))
  };

  const handleUomSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      uom_id: selectedValue,
    });

    setSelectedUom(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      uom_id: fieldError?.uom_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        uom_id: selectedValue,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)
      if (JSON.stringify(validationErrors) !== "{}") return
      // Additional validation for `user_documents`



      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData }

      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData }
      }
      // console.log(payload)
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {

        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // add document



  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="category"
            options={categorySelectOptions}
            value={selectedCategory}
            onSelect={handleCategorySelect}
            placeholder="Select Category"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.category_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="uom"
            options={uomSelectOptions}
            value={selectedUom}
            onSelect={handleUomSelect}
            placeholder="Select UOM"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.uom_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Material Name"
            name="name"
            value={formData?.inputData?.name}
            onChange={onInputChange}
            placeholder="Material Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.name}
          />
        </Col>
        
        <Col md="6" className="mt-3">
          <TextInput
            label="Material Code"
            name="code"
            value={formData?.inputData?.code}
            onChange={onInputChange}
            placeholder="Material Code"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.code}
          />
        </Col>
        <Col md="6" className="mt-3">
          <NumberInput
            label="Unit Cost"
            name="unit_cost"
            value={formData?.inputData?.unit_cost}
            onChange={onInputChange}
            placeholder="Unit Cost"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.unit_cost}
          />
        </Col>


        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Material Description"
            name="descriptions"
            value={formData?.inputData?.descriptions}
            onChange={onInputChange}
            placeholder="Material Descriptions"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.descriptions}
          />
        </Col>

      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default MaterialCreate;
